module.exports = __webpack_public_path__ + "built-card-bottom-right@2x.AHknya_b.png";